import { defineMessages } from 'react-intl';

export const navItemsMessages = defineMessages({
    useMobileAppCta: {
        id: 'navItems.useMobileAppCta',
        defaultMessage: 'Use Mobile App',
        description:
            'Button cta text to prompt the user to download the mobile app.',
    },
});
